import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { AbstractControl, FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { LgdFormControlFactory } from "@tylertech/lgd-reactive-forms";
import { INote } from "@tylertech/tyler-api-types";

@Component({
    selector: "single-note",
    templateUrl: "./singleNote.tmpl.html",
    styleUrls: [
        "./singleNote.component.scss"
    ],
    standalone: false
})
export class SingleNoteComponent implements OnInit, OnDestroy
{
    @Input() readonly model: INote;
    @Input() readonly viewOnly: boolean;

    private readonly destructor$ = new Subject<void>();
    protected readonly descriptionControl: AbstractControl<string>;
    readonly noteForm: FormGroup;

    constructor()
    {
        this.descriptionControl = LgdFormControlFactory.textarea(
            undefined,
            () => this.viewOnly,
            {
                maxLength: 1000,
            });
        this.noteForm = new FormGroup({
            note: this.descriptionControl,
        });
    }

    private get noteControl(): AbstractControl<unknown>
    {
        return this.noteForm.get("note");
    }

    ngOnDestroy(): void
    {
        this.destructor$.next();
        this.destructor$.complete();
    }

    ngOnInit(): void
    {
        if (!this.model)
        {
            throw "singleNote.component | Required binding missing: model";
        }

        // FIXME(DO-7969) - should viewonly be controlling the enabled/disabled state of the form/control?
        this.noteControl.setValue(this.model.Description);
        this.noteControl.valueChanges
            .pipe(takeUntil(this.destructor$))
            .subscribe(
                (newValue: string) =>
                {
                    this.model.Description = newValue;
                });
    }
}
